<script>
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { Send } from 'lucide-svelte'
  import { formatMoney } from '@lib/utils'

  let { offer, open = $bindable(false), onClose, onSuccess } = $props()

  let form = $derived(useForm({
    billing_name: '',
    billing_address: '',
    purchase_order_number: '',
    notes: '',
  }))

  function handleClose() {
    onClose?.()
    $form.reset()
    open = false
  }

  function handleSuccess() {
    onSuccess?.()
    open = false
    $form.reset()
    // We will be redirected
  }

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform((data) => ({ invoice_request: { ...data, offer_id: offer.id } }))
    $form.post('/invoice_requests', { onSuccess: handleSuccess })
  }

</script>

<Modal bind:open title="Request invoice" onClose={handleClose}>

  <p class="text-sm text-gray-500/80 italic mb-8">Please fill in the details below to request an invoice for your membership.</p>

  <Form.Element id="invoice-request-form" {form} onsubmit={handleSubmit}>

    <Form.Items>

      <!-- Offer name (disabled/readonly) -->
      <Form.Item name="offer" value={offer.name} label="Offer" cols={6} disabled readonly />

      <!-- Offer price (disabled/readonly) -->
      <Form.Item name="offer_price" value={formatMoney(offer.amount_cents)} label="Offer price" cols={6} disabled readonly />

      <!-- Business name -->
      <Form.Item name="billing_name" label="Business name" bind:value={$form.billing_name} />

      <!-- Business address -->
      <Form.Item name="billing_address" label="Business address" bind:value={$form.billing_address} hint="To appear on the invoice" />

      <!-- Purchase order number -->
      <Form.Item name="purchase_order_number" label="Purchase order number" bind:value={$form.purchase_order_number} hint="Optional — include if your organisation requires a PO number on the invoice" />

      <!-- Notes -->
      <Form.Item name="notes" label="Notes" type="textarea" bind:value={$form.notes} hint="Any additional information you'd like to add" />
      
    </Form.Items>
    
  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form="invoice-request-form" text="Request invoice" variant="submit" Icon={Send} loading={$form.processing} />
  {/snippet}
  
</Modal>
